<template>
  <div class="show-mortgage-properties" v-bind:class="{loaded}">
    <a-collapse v-model="activeKey">
      <a-collapse-panel v-for="mortgageProperty in mortgageProperties" :key="mortgageProperty.id + ''"
                        :header="mortgageProperty.property.data.description">
        <MortgagePropertyShowComponent :mortgage-property="mortgageProperty"/>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import MortgagePropertyShowComponent from '~/modules/mortgage_property/components/ShowComponent'
import mortgageApi from "~/api/mortgage"
import mortgagePropertyApi from "~/api/mortgage_property"

export default {
  name: "MortgageShowMortgagePropertiesComponent",
  components: {
    MortgagePropertyShowComponent,
  },
  props: {
    mortgageId: {
      required: false,
      default: null
    },
    mortgageProp: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      mortgageProperties: [],
      activeKey: [],
      createModalVisible: false,
      selectedProperty: null,
      loaded: false
    };
  },
  mounted() {
    if (this.mortgageProp === null && this.mortgageId === null) {
      throw new Error('Either the mortgage object or mortgage id is required.');
    }

    if (this.mortgageProp === null) {
      mortgageApi.find(this.mortgageId).then(response => {
        this.mortgage = response.data;
        this.initMortgageProperties();
      });
    } else {
      this.mortgage = this.mortgageProp;
      this.initMortgageProperties();
    }
  },
  computed: {
    hasSelectedProperty() {
      return this.selectedProperty !== null;
    }
  },
  methods: {
    initMortgageProperties() {
      mortgagePropertyApi.paginateByMortgage(this.mortgage.id, 1, 50, ['property', 'property.valuations']).then(response => {
        this.mortgageProperties = response.data;

        if (typeof this.mortgageProperties[0] !== "undefined") {
          this.activeKey = [this.mortgageProperties[0].id + ''];
        }

        this.loaded = true;
      });
    },
    handleDeleteClick(mortgageProperty) {
      event.stopPropagation();

      this.$confirm({
        title: 'Onderpand ontkoppelen',
        content: 'Weet je zeker dat je dit pand als onderpand wil ontkoppelen van de hypotheek?',
        okText: 'Ja',
        cancelText: 'Annuleren',
        onOk: () => {
          mortgagePropertyApi.delete(mortgageProperty.id).then(response => {
            this.mortgageProperties = this.mortgageProperties.filter(item => {
              return item.id !== mortgageProperty.id;
            })
          });
        },
        onCancel() {
        },
      });
    },
    handleShowMortgagePropertyCreate() {
      this.selectedProperty = null;
      this.createModalVisible = true;
    },
    onPropertySelected(property) {
      this.selectedProperty = property;
    },
    handleCreateMortgageProperty() {
      return new Promise((resolve, reject) => {
        if (!this.hasSelectedProperty) {
          this.$message.warning('Selecteer eerst een pand');
          reject();
        } else {
          mortgagePropertyApi.create({
            mortgage_id: this.mortgage.id,
            property_id: this.selectedProperty.id,
          }).then(() => {
            this.createModalVisible = false;
            this.initMortgageProperties();
            resolve();
          }).catch(error => {
            let errorResponse = error.response.data;
            if (errorResponse.error && errorResponse.error.errors) {
              for (let attribute in errorResponse.error.errors) {
                let errors = errorResponse.error.errors[attribute];
                errors.forEach(error => {
                  this.$notification['error']({
                    message: 'Er ging iets mis',
                    description: error,
                  });
                })
              }
            }
            reject();
          });
        }
      });
    },
    handleCancelCreateMortgageProperty() {
      this.createModalVisible = false;
    }
  }
}
</script>
<style scoped>
.edit-mortgage-properties {
  position: relative;
  margin-bottom: 15px;
}

.create-button {
  margin-top: 15px;
}
</style>
